// Offer javascript

function updateChristmasOfferFromCartAPI() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      updateChristmasOffer(cart);
    });
}

function updateChristmasOffer(cart) {
  const wrapper = document.getElementById("xmas-offer-wrapper");
  if (!wrapper) return;

  const total = cart.items_subtotal_price / 100;
  const tier20 = 2000;
  const tier30 = 3000;

  wrapper.innerHTML = "";

  let message = "";
  let percentage = 0;

  if (total < tier20) {
    const remaining = tier20 - total;
    message = `🎁 Add ₹${remaining} more to unlock <span class="highlight">20% OFF</span>!`;
    percentage = (total / tier20) * 100;

  } else if (total < tier30) {
    const remaining = tier30 - total;
    message = `You unlocked <strong>20% OFF</strong> 🎉<br> 🎁 Add ₹${remaining} more to unlock <span class="highlight">30% OFF</span>!`;
    percentage = (total / tier30) * 100;

  } else {
    message = `🎅 Congrats! You unlocked <span class="highlight">30% OFF</span>!`;
    percentage = 100;
  }

  wrapper.innerHTML = `
    <div class="xmas-offer-bar">
      <div class="xmas-offer-progress" style="width:${percentage}%"></div>
    </div>
    <p class="xmas-offer-text">${message}</p>
  `;
}

// 🔥 Critical: Symmetry events for AJAX cart updates
document.addEventListener("dispatch:cart-drawer:open", updateChristmasOfferFromCartAPI);
document.addEventListener("dispatch:cart-drawer:refresh", updateChristmasOfferFromCartAPI);

// Also update after items merge
document.addEventListener("on:cart:after-merge", updateChristmasOfferFromCartAPI);

// Update once on first load
document.addEventListener("DOMContentLoaded", updateChristmasOfferFromCartAPI);
